import { Trans } from "@lingui/react/macro";
import type { MetalCommitmentPeriodEnum } from "@warrenio/api-spec/spec.oats.gen";
import type { ReactNode } from "react";

export type MetalBillingPeriod = MetalCommitmentPeriodEnum | 0;

/** @public */
export const periodLabels = {
    0: <Trans comment="Server commitment period">Hourly</Trans>,
    730: <Trans comment="Server commitment period">Monthly</Trans>,
    2190: <Trans comment="Server commitment period">Quarterly</Trans>,
    8760: <Trans comment="Server commitment period">Yearly</Trans>,
} satisfies Record<MetalBillingPeriod, ReactNode>;

export const periodUnits = {
    0: <Trans comment="Time period unit">hour</Trans>,
    730: <Trans comment="Time period unit">month</Trans>,
    2190: <Trans comment="Time period unit">quarter</Trans>,
    8760: <Trans comment="Time period unit">year</Trans>,
} satisfies Record<MetalBillingPeriod, ReactNode>;

export const t_billingCyclesDescription = (
    <Trans comment="Description for billing period field">
        In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year.
    </Trans>
);
